import { useCallback } from 'react';
import { useTheme } from '@mui/material';
import { ReactFlowState, useStore } from 'reactflow';
import { useLineageGraphContext } from '../LineageGraphContext';
import { ReactFlowNodeData } from '../types';
import { getGraphNodeBorderColor } from '../utils/lineageGraphUtils';
import useLineageNodeColors from './useLineageNodeColors';

const useCompactPanelBorderColor = (panelNodeId?: string) => {
  const theme = useTheme();
  const { highlightedNode } = useLineageGraphContext();
  const panelNodeData = useStore(
    useCallback(
      (state: ReactFlowState) =>
        panelNodeId
          ? (state.nodeInternals.get(panelNodeId)?.data as
              | ReactFlowNodeData
              | undefined)
          : undefined,
      [panelNodeId],
    ),
  );
  const nodeColors = useLineageNodeColors(panelNodeData);

  return getGraphNodeBorderColor(theme.palette, {
    isHighlighted:
      (!!panelNodeId && highlightedNode?.id === panelNodeId) ||
      !!panelNodeData?.isOnHighlightPath,
    isRestricted: panelNodeData?.metadata.isRestricted === true,
    colorByBorderColor: nodeColors.border,
  });
};

export default useCompactPanelBorderColor;
